import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "emergency";

const GET_ALL_EMERGENCY_URL = `${prefix}/all`;
const UPDATE_EMERGENCY_URL = `${prefix}/update-by-id`;
const COUNT_EMERGENCY_URL = `${prefix}/count`;

/**
 * @func getEmergency
 * @desc get all home banner data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} home banner array
 */
export const getEmergency = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_EMERGENCY_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getEmergency");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getEmergency */

/**
/**
 * @func updateEmergency
 * @desc update user by id
 * @author jew
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const updateEmergency = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_EMERGENCY_URL}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateEmergency");
        if (err) throw err;
        return undefined;
    }
};

/** End @func updateEmergency */

/**
/**
 * @func countEmergency
 * @desc update user by id
 * @author jew
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const countEmergency = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(COUNT_EMERGENCY_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "countEmergency");
        if (err) throw err;
        return undefined;
    }
};

/** End @func countEmergency */
